import ApiService from '../../../../../services/ApiService'
import Utils from '../../../../../Utils/FormatDate'
import AboutUser from '../AboutUser/AboutUser.vue'
import ManageUser from '../manage.vue'
import GenerateLink from '../GenerateLink/GenerateLink.vue'

export default {
  data: () => ({
    visible: false,
    totalItensOnPage: 0,
    dialog: false,
    editDialog: false,
    aboutDialog: false,
    dialogKey: false,
    generateLinkDialog: false,
    loading: false,
    userLoading: false,
    unidadeLoading: false,
    institutionLoading: false,
    expanded: [],
    users: [],
    institutionId: 0,
    institutions: [],
    unidadeId: 0,
    unidades: [],
    currentUser: {},
    userLogged: {},
    offices: [
      'Auxiliar',
      'Coordenador',
      'Enfermeiro',
      'Engenheiro',
      'Estagiário',
      'Recepcionista',
      'Supervisor',
      'Técnico',
    ],
    levels: [
      { text: 'Master', value: 0 },
      { text: 'Administrador', value: 1 },
      { text: 'Usuário', value: 2 },
    ],
    levelsAdmin: [
      { text: 'Supervisor Principal', value: 8 },
      { text: 'Supervisor', value: 2 },
      { text: 'Operador', value: 3 },
      { text: 'Coordenador Op.', value: 4 },
      { text: 'Coordenador Setor Assistencial', value: 5 },
      { text: 'Solicitador', value: 6 },
    ],
    levelsSupervisor: [
      { text: 'Operador', value: 3 },
      { text: 'Coordenador Op.', value: 4 },
      { text: 'Coordenador Setor Assistencial', value: 5 },
      { text: 'Solicitador', value: 6 },
    ],
    status: ['Ativo', 'Inativo'],
    page: 1,
    totalPages: 1,
    pageSize: 10,
    sizes: [10, 30, 90, 180],
    totalItems: 0,
    apiService: new ApiService(),
    filter: {
      page: 1,
      pageSize: 10,
      name: null,
      email: null,
      userOffice: null,
      unidadeId: 0,
      institutionId: 0,
      userType: null,
      status: null,
    },
    userName: null,
    userOffice: null,
    userEmail: null,
    userType: null,
    userStatus: null,
    error: false,
    show: false,
    message: '',
    headers: [
      {
        text: '',
        align: 'center',
        value: '',
        sortable: false,
      },
      {
        text: 'Nome',
        align: 'center',
        value: 'name',
      },
      {
        text: 'E-mail',
        align: 'center',
        value: 'email',
        sortable: false,
      },
      {
        text: 'Status',
        align: 'center',
        value: 'status',
        sortable: false,
      },
      {
        text: 'Nível no Sistema',
        align: 'center',
        value: 'mainType',
        sortable: false,
      },
      {
        text: 'Nível na instituição',
        align: 'center',
        value: 'institutions',
        sortable: false,
      },
      {
        text: 'Ultimo Acesso',
        align: 'center',
        value: 'lastLogin',
        sortable: false,
      },
      {
        text: 'Ações',
        align: 'center',
        value: 'actions',
        sortable: false,
        width: 200,
      },
    ],
    headersMobile: [
      {
        text: 'Nome',
        align: 'center',
        value: 'name',
      },
      {
        text: 'Ações',
        align: 'center',
        value: 'actions',
        sortable: false,
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    institution: {},
  }),

  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId =
      this.institution.userType < 2
        ? 0
        : JSON.parse(localStorage.getItem('institution')).id

    this.unidadeId =
      this.institution.userType > 2 && this.institution.userType != 8
        ? this.userLogged.unidadeId
        : 0

    this.searchUnidades()
    this.getInstitutions()
    this.updateTable()
  },

  components: {
    ManageUser,
    AboutUser,
    GenerateLink,
  },

  methods: {
    isNumber(value) {
      return typeof value === 'number'
    },

    isInactive(value) {
      if (value.department) {
        return value.department.status == 1 ? 'departmentInactive' : ''
      }
      return 'departmentInactive'
    },

    formatDate(date) {
      return Utils.moment(date)
    },

    unidadeName(value) {
      const unidade = this.unidades.find((unidade) => unidade.id === value)

      if (unidade) {
        return unidade.name
      } else {
        return 'Sem registro'
      }
    },

    institutionName(value) {
      const institution = this.institutions.find(
        (institution) => institution.id === value
      )

      if (institution) {
        return institution.name
      } else {
        return 'Sem registro'
      }
    },

    addUser() {
      this.dialogKey = !this.dialogKey
      this.dialog = true
    },

    openGenerateLinkDialog() {
      this.generateLinkDialog = true
    },

    closeGenerateLinkDialog() {
      this.generateLinkDialog = false
    },

    editUser(user) {
      this.currentUser = user
      this.dialogKey = !this.dialogKey
      this.editDialog = true
    },

    deleteUser(user) {
      this.currentUser = user
      this.dialogKey = !this.dialogKey
      this.deleteDialog = true
    },

    closeDialog() {
      this.dialog = false
      this.editDialog = false
      this.aboutDialog = false

      this.updateTable()
    },

    openAbout(user) {
      this.currentUser = user
      this.dialogKey = !this.dialogKey
      this.aboutDialog = true
    },

    filterTable() {
      this.page = 1
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize

      this.filter.name = this.userName
      this.filter.userOffice =
        this.userOffice != null ? this.offices.indexOf(this.userOffice) : null
      this.filter.email = this.userEmail
      this.filter.status = this.status.indexOf(this.userStatus)

      this.updateTable()
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService.get('institution/list').then((response) => {
        this.institutions = response.content
        this.institutionLoading = false
      })
    },

    async searchUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async updateTable() {
      this.loading = true
      this.filter.unidadeId = this.unidadeId
      this.filter.institutionId = this.institutionId
      this.filter.UserTypeLogged = this.institution.userType

      await this.apiService.post('user/list', this.filter).then((response) => {
        this.totalPages = response.content.pager.totalPages
        this.users = response.content.data

        this.totalItensOnPage = response.content.data.length
        this.totalItems = response.content.pager.totalItems
        this.loading = false
      })
    },

    reset() {
      this.institutionId =
        this.institution.userType < 2
          ? 0
          : JSON.parse(localStorage.getItem('institution')).id
      this.unidadeId =
        this.institution.userType > 2 && this.institution.userType != 8
          ? this.userLogged.unidadeId
          : 0
      this.userName = null
      this.userEmail = null
      this.userOffice = null
      this.userType = null
      this.userStatus = null
      this.filter = {
        page: 1,
        pageSize: this.pageSize,
        name: null,
        email: null,
        userOffice: null,
        unidadeId: 0,
        userType: null,
        status: null,
      }
      this.updateTable()
    },
  },

  watch: {
    pageSize() {
      this.filter.pageSize = this.pageSize
      this.updateTable()
    },

    page() {
      this.filter.page = this.page
      this.updateTable()
    },
  },
}
